export function normalizeArabicPersianChars(text) {
  return text
    .normalize('NFC')                 // Normalize composed chars
    .replace(/ك/g, 'ک')               // Arabic Kaf to Persian Kaf
    .replace(/ي/g, 'ی')               // Arabic Yeh to Persian Yeh
    .replace(/ة/g, 'ه')               // Teh Marbuta to Heh
    .replace(/‌/g, ' ')               // ZWNJ (Zero-width non-joiner) to space
    .replace(/\u0654/g, '')     //  Remove Hamza Above (ٔ)

    // Fix hamza above Yeh (ئ) → Persian Yeh + hamza (یٔ)
    .replace(/ئ/g, 'یٔ')

    .trim();
}

export function sanitizeText(text) {
  // Keep letters (Latin & Arabic), numbers, spaces, and dashes
  return text.replace(/[^a-zA-Z0-9\u0600-\u06FF\s\-]/g, '').trim();
}

export function createSlug(input, options = {}) {
  const {
    lowercase = true,
    replaceSpacesWith = '-',
    maxLength = 100,
    normalizeFaAr = true,
  } = options;

  let text = input;

  if (normalizeFaAr) {
    text = normalizeArabicPersianChars(text);
  }

  text = sanitizeText(text);

  // Replace multiple spaces with single space
  text = text.replace(/\s+/g, ' ');

  // Replace spaces with separator (usually dash)
  text = text.replace(/\s/g, replaceSpacesWith);

  // Collapse multiple separators
  const sepEscaped = replaceSpacesWith.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  text = text.replace(new RegExp(`${sepEscaped}{2,}`, 'g'), replaceSpacesWith);

  // Trim separator from start and end
  text = text.replace(new RegExp(`^${sepEscaped}+|${sepEscaped}+$`, 'g'), '');

  if (lowercase) {
    text = text.toLowerCase();
  }

  if (text.length > maxLength) {
    text = text.slice(0, maxLength).replace(new RegExp(`${sepEscaped}+$`), '');
  }

  return text;
}
